import React from 'react'
import func from "../../../services/functions"
import CellInput, { CellTextarea } from "../../global/CellInput"
import moment from "moment"
import { useTranslation } from "react-i18next";


export const useBankJournalColumns = ({ transactions }) => {
    const { t } = useTranslation('translations');
    const directionOptions = [
        { label: t("bankJournal.credit"), value: "C" },
        { label: t("bankJournal.debit"), value: "D" }
    ];
    return [
        {
            header: t("payRoll.transactionDate"),
            field: 'bookingDate',
            style: { minWidth: "200px", maxWidth: "250px" },
            sortable: true,
            default: true,
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false
            },
            formattedExportValue: true,
            preventExcelFormat: true,
            mobile: { priority: 1, group: "dates" },
            body: transaction => transaction.bookingDate ? moment(transaction.bookingDate).format("DD/MM/YYYY HH:mm") : ""
        },
        {
            header: t("bankJournal.transactionNo"),
            sortable: true,
            field: 'transactionId',
            style: { minWidth: "200px", maxWidth: "250px" },
            filter: true,
            mobile: { priority: 1, group: "identity" },
            body: transaction => <CellInput value={transaction?.transactionId ?? ""} width={220} onFocus={(event) => event.target.select()} />
        },
        {
            header: t("bankJournal.transactionCode"),
            field: 'transactionCode',
            style: { minWidth: "200px", maxWidth: "300px" },
            filter: true,
            default: false,
            mobile: { priority: 3 },
        },
        {
            header: t("bankJournal.transactionDesc"),
            field: 'proprietaryBankTransactionCode',
            style: { minWidth: "300px", maxWidth: "300px" },
            body: transaction => transaction.proprietaryBankTransactionCode || "",
            default: true,
            mobile: { priority: 2 },
        },
        {
            header: t("bankJournal.details"),
            field: 'additionalInformation',
            style: { minWidth: "230px", maxWidth: "300px" },
            body: transaction => <CellTextarea width={250} value={transaction.additionalInformation ?? ""} onFocus={(event) => event.target.select()} />,
            default: true,
            mobile: { priority: 2 },

        },
        {
            header: t("bankJournal.accountCurrency"),
            field: 'accountCurrency',
            style: { minWidth: "200px", maxWidth: "300px" },
            // body: () => transactions?.accountCurrency || "",
            formattedExportValue: true,
            default: true,
            mobile: { priority: 1, isBadge: true, group: "status" },

        },
        {
            header: t("bankJournal.transactionAmount"),
            field: 'transactionAmount',
            style: { minWidth: "200px", maxWidth: "300px" },
            sortable: true,
            align: "right",
            body: transaction => func.getFormattedMoneyValue(transaction.transactionAmount),
            default: true,
            mobile: { priority: 1, group: "financial" },
        },
        {
            header: t("bankJournal.direction"),
            field: 'direction',
            style: { minWidth: "150px", maxWidth: "200px" },
            filter: true,
            filterConfig:{
                options: directionOptions
            },
            filterType: "DROPDOWN",
            body: transaction => !transaction.debtorId ? "C" : "D",
            formattedExportValue: true,
            default: true,
            mobile: { priority: 1, isBadge: true, group: "status" },
        },
        {
            header: t("bankJournal.customerName"),
            field: 'legalNameOfCounterpart',
            style: { minWidth: "220px", maxWidth: "250px" },
            filter: true,
            body: transaction => !transaction?.debtorId ? transaction.debtorName : transaction?.creditorName,
            formattedExportValue: true,
            default: true,
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },
        {
            header: t("bankJournal.customerNuis"),
            field: 'customerNUIS',
            style: { minWidth: "200px", maxWidth: "240px" },
            filter: true,
            body: transaction => !transaction.debtorId ? transaction?.debtorId : transaction?.creditorId,
            formattedExportValue: true,
            default: true,
            mobile: { priority: 2 },
        },
        {
            header: t("invoice.FIC"),
            field: 'nivf',
            style: { minWidth: "200px", maxWidth: "300px" },
            filter: true,
            mobile: { priority: 3 },
            body: transaction => {
                const noOfInvocies= transaction?.transactionDetails?.batchNumberOfTransactions
           return  <CellTextarea width={240} value={(transaction?.nivf?? "").split(",").join(",\n") ?? ""}  />

        },

        },

    ];
};